export function lessonPlayback(lesson, apiUrl, allowMp4 = true) {
  const original = lesson.video?.url || lesson.recording?.finalVideo?.url;
  const key = lesson.video?.key || lesson.recording?.finalVideo?.key;
  const hls = lesson.hls;
  const version = hls?.prefix?.split("/").filter(Boolean).at(-1);
  if (hls?.status === "ready" && key && hls.sourceKey === key && /^[a-f\d-]{36}$/i.test(version || "")) {
    return { src: `${apiUrl.replace(/\/$/, "")}/api/classes/${lesson._id}/hls/${version}/master.m3u8`, progressSource: original, mimeType: "application/x-mpegURL", renditions: hls.renditions || [], nestedRenditions: hls.prefix.startsWith("courses/") };
  }
  if (allowMp4 && key && /^[a-f\d]{64}$/.test(lesson.mp4Fallback?.sourceId || "")) {
    return { src: `${apiUrl.replace(/\/$/, "")}/api/classes/${lesson._id}/source/${lesson.mp4Fallback.sourceId}.mp4`,
      progressSource: original, mimeType: lesson.mp4Fallback.mimeType || "video/mp4", fallback: true };
  }
  return { src: undefined, progressSource: original, processing: Boolean(key || original) && hls?.status !== "failed", failed: hls?.status === "failed" };
}
